import request from '@/utils/request'

// 查询统计信息列表分页
export function fetchList(query) {
    return request({
        url: '/fix/order/model/caliber/statistics',
        method: 'get',
        params: query,
    })
}
// 查询统计信息列表分页
export function fetchPublic(query) {
    return request({
        url: '/fix/06d920ee1458ee7f28993a32157453cb/public/page',
        method: 'get',
        params: query,
    })
}
// 删除品牌报单
export function delObj(data) {
    return request({
        url: '/taxation/brand/delete',
        method: 'post',
        data: data,
    })
}